import { Alert, Box, Card, CircularProgress, Typography } from '@mui/material';
import React from 'react';

import { useApiData } from '../../hooks/useApiData';
import { useUser } from '../../hooks/useUser';

const isForbidden = (err: Error | null) =>
  (err as any)?.response?.status === 403;

const AttendanceCard: React.FC = () => {
  const { user } = useUser();

  const showClock = !user?.is_swipeclock_enabled_no_clock;

  const {
    data: clockUrl,
    error: clockError,
    loading: clockLoading,
  } = useApiData<string>((api) => api.attendance.getClockRedirect());

  if (showClock && !clockLoading && isForbidden(clockError)) {
    return null;
  }

  if (showClock && !clockLoading && (clockError || !clockUrl)) {
    return (
      <Alert severity="error">
        An error occured while loading the attendance page. Please refresh and
        try again
      </Alert>
    );
  }

  const isLoading = showClock && clockLoading;

  return (
    <Card
      sx={{
        borderRadius: 3,
        p: 3,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box sx={{ mb: 2 }}>
        <Typography variant="h5">Time & attendance</Typography>
      </Box>
      {isLoading ? (
        <Box sx={{ textAlign: 'center', py: 4 }}>
          <CircularProgress />
        </Box>
      ) : (
        showClock &&
        clockUrl && (
          <Box
            sx={{
              borderRadius: 2,
              overflow: 'hidden',
              border: '1px solid #f1f3f4',
            }}
          >
            <iframe
              src={clockUrl}
              title="SwipeClock"
              style={{
                width: '100%',
                height: 340,
                border: 'none',
                display: 'block',
              }}
            />
          </Box>
        )
      )}
    </Card>
  );
};

export default AttendanceCard;
